
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 17 10","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_4800_20121)","fill":"#000032"}},[_c('path',{attrs:{"d":"M3.626 6.012H1.119a.632.632 0 00-.66.603.634.634 0 00.66.67h2.507a.634.634 0 00.596-.67.633.633 0 00-.596-.603zM16.195 6.012H6.133a.634.634 0 00-.596.668.633.633 0 00.596.604h10.062a.634.634 0 00.596-.669.633.633 0 00-.596-.603zM1.119 2.194h7.527a.632.632 0 00.66-.604.634.634 0 00-.66-.668H1.119a.632.632 0 00-.66.603.634.634 0 00.66.669zM16.195 8.558h-7.55a.634.634 0 00-.596.67.633.633 0 00.596.603h7.55a.634.634 0 00.596-.669.633.633 0 00-.596-.604zM6.133 8.558H1.12a.632.632 0 00-.66.604.634.634 0 00.66.669h5.014a.632.632 0 00.66-.604.634.634 0 00-.66-.669zM11.16 3.467H1.116a.632.632 0 00-.66.603.634.634 0 00.66.67h10.042a.634.634 0 00.596-.67.633.633 0 00-.596-.603zM16.195 3.467h-2.519a.634.634 0 00-.596.668.633.633 0 00.596.604h2.52a.634.634 0 00.595-.669.633.633 0 00-.596-.603zM11.16 2.194h5.035a.634.634 0 00.596-.669.633.633 0 00-.596-.603H11.16a.632.632 0 00-.66.603.634.634 0 00.66.669z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_4800_20121"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(.456 .92)","d":"M0 0h16.337v8.911H0z"}})])])])
          )
        }
      }
    